import axios from 'axios';

// Prefer environment-configured backend URL
// Set REACT_APP_API_BASE_URL in environment variables for each environment:
// - Development: .env.development.local or Vercel dev env vars
// - Staging: .env.staging.local or Vercel preview env vars
// - Production: .env.production.local or Vercel production env vars
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
  (process.env.NODE_ENV === 'production' ? '' : 'http://127.0.0.1:3000');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),
  
  register: (userData: {
    name: string;
    email: string;
    password: string;
    password_confirmation: string;
    role?: string;
  }) => api.post('/auth/register', userData),
  
  me: () => api.get('/auth/me'),
};

export const coursesAPI = {
  getAll: (params?: { difficulty?: string; category?: string }) =>
    api.get('/api/courses', { params }),
  
  getById: (id: number) => api.get(`/api/courses/${id}`),
  
  create: (courseData: {
    title: string;
    description: string;
    duration: string;
    price: number;
    difficulty: string;
    category: string;
  }) => api.post('/api/courses', courseData),
  
  update: (id: number, courseData: any) =>
    api.put(`/api/courses/${id}`, courseData),
  
  delete: (id: number) => api.delete(`/api/courses/${id}`),
};

export const contactsAPI = {
  create: (contactData: {
    to_email: string;
    from_name: string;
    from_email?: string;
    phone?: string;
    course?: string;
    message?: string;
    subject?: string;
  }) => api.post('/api/contacts', { contact: contactData }),
  
  getAll: () => api.get('/api/contacts'),
  
  getById: (id: number) => api.get(`/api/contacts/${id}`),
};

export const blogsAPI = {
  getAll: () => api.get('/api/blogs'),
};

export default api; 
